import {
    ADD_SERVICE_BOOKING_LOADING,
    ADD_SERVICE_BOOKING_FAILED,
    ADD_SERVICE_BOOKING_SUCCESS
    } from "../types"
    
    const initialState = {
      loading: false,
      error: false,
      message: null,
    }
    
    export default function (state = initialState, action) {
      switch (action.type) {
        case ADD_SERVICE_BOOKING_LOADING:
          return {
            ...state,
            loading: true,
            error: false,
            message: null,
          }
        case ADD_SERVICE_BOOKING_FAILED:
          return {
            ...state,
            loading: false,
            error: true,
            message: action.payload,
          }
        case ADD_SERVICE_BOOKING_SUCCESS:
          return {
            ...state,
            loading: false,
            error: false,
            message: null,
          }
        default:
          return state
      }
    }